import { CSSProperties, FC, SyntheticEvent } from 'react'

import clsx from 'clsx'

import MTravelLogo from 'shared/icons/mtravel_icon_text.svg'

import s from './styles.module.scss'

interface ImageOptimizedProps {
  className?: string
  src?: string
  alt?: string
  errorImage?: string
  priority?: boolean
  width?: number | string
  height?: number | string
  wrapperClassName?: string
  aspectRatio?: string
  objectFit?: CSSProperties['objectFit']
}

export const ImageOptimized: FC<ImageOptimizedProps> = ({
  className,
  src,
  alt,
  errorImage,
  priority = false,
  width,
  height,
  wrapperClassName,
  aspectRatio,
  objectFit,
}) => {
  const handleError = (e: SyntheticEvent<HTMLImageElement>) => {
    if (errorImage && e.currentTarget.src !== errorImage) {
      e.currentTarget.src = errorImage
    } else if (e.currentTarget.src !== MTravelLogo) {
      e.currentTarget.src = MTravelLogo
    }
  }

  const finalSrc = src || errorImage || MTravelLogo
  const wrapperStyle: CSSProperties = {
    aspectRatio,
    width,
    height,
  }
  const imageStyle: CSSProperties = {
    objectFit,
  }

  return (
    <span
      className={clsx(s.wrapper, wrapperClassName)}
      style={wrapperStyle}
    >
      <img
        src={finalSrc}
        alt={alt || ''}
        className={clsx(s.image, className)}
        loading={priority ? 'eager' : 'lazy'}
        decoding="async"
        width={width}
        height={height}
        style={imageStyle}
        onError={handleError}
      />
    </span>
  )
}
